import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UnidadeService } from '@app/services/unidade.service';
import { ConsultasService } from '@app/services/consultas.service';
import { Unidade } from '@app/models/unidade.model';
import { IdDescricao } from '@app/models/util/id-descricao';


@Component({
  selector: 'app-unidade-form',
  templateUrl: './unidade-form.component.html'
})
export class UnidadeFormComponent implements OnInit {

  aguardandoSolicitacao = false;
  titulo: string;
  lstErros: string[];
  lstCidades: IdDescricao[] = [];
  unidade: Unidade = new Unidade();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private unidadeService: UnidadeService,
    private consultasService: ConsultasService
  ) { }

  ngOnInit() {
    this.consultasService.consultar('CIDADE').subscribe(data => this.lstCidades = data);
    this.route.params.subscribe(params => {
      const id = params['id'];
      this.titulo = id ? 'Editar Unidade' : 'Nova Unidade';

      if (!id) {
        return;
      }

      this.unidadeService.obterPorId(id).toPromise().then(
        data => this.unidade = data,
        () => this.router.navigate(['./configuracoes/unidade']));
    });
  }

  onSubmit() {
    this.aguardandoSolicitacao = true;
    this.unidadeService.gravar(this.unidade).subscribe(
      () => this.router.navigate(['./configuracoes/unidade']),
      (data: any) => {
        if (data.error) {
          this.lstErros = data.error.errors;
        }
        this.aguardandoSolicitacao = false;
      });
  }

  limpaCidadeRateio(){
    if(this.unidade.Rateio)
      this.unidade.CidadeId = null;
  }
}
